import { jsx as _jsx } from "react/jsx-runtime";
import { useContactCardSection } from "@/contexts/contact";
import { BuildingFilledIcon } from "@gemini/icons";
import { Avatar } from "@gemini/ui";
const AgencyLogo = () => _jsx(BuildingFilledIcon, {});
export const StickyContactFormAvatar = () => {
    const contactCardSection = useContactCardSection();
    const { agencyLogo } = contactCardSection !== null && contactCardSection !== void 0 ? contactCardSection : {};
    return (agencyLogo === null || agencyLogo === void 0 ? void 0 : agencyLogo.logoUrl) ? (_jsx(Avatar, { label: "Avatar", type: "rectangle-fluid", imageUrl: agencyLogo === null || agencyLogo === void 0 ? void 0 : agencyLogo.logoUrl, maxSize: "120x48", hasPaddingDisabled: true, hasBorderDisabled: false })) : (_jsx(Avatar, { label: "Avatar", icon: AgencyLogo, type: "square", size: "48" }));
};
